import http from "./base-api";

const upload = (file) => http.post("/upload", file)

const create = (photo) => http.post("/photos", photo);

const list = () => http.get("/photos");

const listByUser = (userId) => http.get(`/photos/${userId}`);

const deletePhoto = (id) => http.delete(`/photos/${id}`);

const photosApi = {
  upload,
  create,
  list,
  listByUser,
  deletePhoto,
};

export default photosApi;